// 💾 src/components/trade/BalanceHeader.tsx
import React, { useEffect, useState } from "react"
import { FaEye, FaEllipsisV } from "react-icons/fa"
import { auth } from "../../../../../services/firebase"
import "./style/BalanceHeader.scss"

type MockBalance = {
  id: string
  amount: number
  eurRate?: number
}

const BalanceHeader: React.FC = () => {
  const user = auth.currentUser
  const [balanceUSDT, setBalanceUSDT] = useState<number>(0)
  const [balanceEUR, setBalanceEUR] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>("")

  useEffect(() => {
    const fetchData = async () => {
      if (!user) {
        setError("Not signed in")
        setLoading(false)
        return
      }

      try {
        let usdtAmt = 0
        let eurVal = 0

        // 🔎 Only load from mockBalances.json
        try {
          const resp = await fetch("/mockBalances.json")
          const mockList: MockBalance[] = await resp.json()

          console.log("Loaded mock list:", mockList) // debug
          console.log("Current UID:", user.uid)      // debug

          const mock = mockList.find(m => m.id === user.uid)
          console.log("Matched mock entry:", mock)   // debug

          if (mock) {
            usdtAmt = mock.amount
            eurVal = mock.eurRate ?? 0
          } else {
            usdtAmt = 0
            eurVal = 0
          }
        } catch (jsonErr) {
          console.warn("Mock balances not available:", jsonErr)
          usdtAmt = 0
          eurVal = 0
        }

        setBalanceUSDT(usdtAmt)
        setBalanceEUR(eurVal)
      } catch (e) {
        console.error("BalanceHeader error:", e)
        setError("Failed to load balance")
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [user])

  return (
    <div className="balance-header">
      <div className="balance-left">
        <div className="label">
          Estimated Balance <FaEye className="eye" />
        </div>

        {loading ? (
          <div className="balance-value">Loading…</div>
        ) : error ? (
          <div className="balance-value error">{error}</div>
        ) : (
          <>
            <div className="balance-value">
              {balanceUSDT.toFixed(2)} <span className="currency">USDT</span>
            </div>
            <div className="balance-convert">
              ≈ {balanceEUR.toFixed(2)} <span>EUR</span>
            </div>
          </>
        )}
      </div>

      <div className="balance-actions">
        <button className="blue">Deposit ▾</button>
        <button>Withdraw</button>
        <button>Transfer</button>
        <button className="circle">
          <FaEllipsisV />
        </button>
      </div>
    </div>
  )
}

export default BalanceHeader
